<template>
    <input type="password" :placeholder="item.placeholder" v-model="item.password" autocomplete="on">
</template>
<script>
    export default {
        props : ['item']
    }
</script>
<style lang="scss">

</style>